/* eslint-disable react/no-array-index-key */
import { FC, useEffect, useMemo, useState } from 'react';

import { TColorProp } from 'styled-components';

import { ISwtichToggleOption } from '~/common/interfaces/i-switch-toggle-option';

import {
  SwitchToggleContainer,
  ToggleItem,
  ToggleItemOverflow,
  ToggleWrapper,
} from './styles';
import { Typography } from '../Typograph';
import { IFormLabelProps } from '../FormLabel/types';
import { FormLabel } from '../FormLabel';

interface ISwitchToggleProps {
  label?: IFormLabelProps;
  switches: ISwtichToggleOption[];
  current: string;
  selectedTextColor?: TColorProp;
  fixedItemWidth?: string;
  height?: string;
  fullWidth?: boolean;
  onChange: (_switch: string) => void;
}
export const SwitchToggle: FC<ISwitchToggleProps> = ({
  label,
  switches,
  current,
  selectedTextColor,
  fixedItemWidth,
  fullWidth = false,
  height = '36px',
  onChange,
}) => {
  const [render, setRender] = useState<boolean>(false);

  const selectedSwitchDynamicProps = useMemo(() => {
    if (!render) {
      return { width: '0px', left: '0px' };
    }

    const selectedElement = document?.getElementById?.(
      `switch-option-${current}`
    );

    const option = switches.find((where) => where.key === current);
    if (!selectedElement || !render || !option) {
      return { width: '0px', left: '0px' };
    }

    const { offsetWidth, offsetLeft } = selectedElement;

    return {
      width: `${offsetWidth}px`,
      left: `${offsetLeft}px`,
    };
  }, [current, render, switches]);

  useEffect(() => {
    setRender(true);
  }, []);

  return (
    <SwitchToggleContainer
      {...(!!fullWidth && {
        style: {
          width: '100%',
        },
      })}
    >
      {label && <FormLabel {...label} />}

      <ToggleWrapper height={height}>
        {switches.map((_switch, index) => (
          <ToggleItem
            disabled={_switch.disabled}
            withoutHoverColor={!!selectedTextColor && current === _switch.key}
            key={String(index)}
            onClick={() => (!_switch.disabled ? onChange(_switch.key) : null)}
            id={`switch-option-${_switch.key}`}
            {...(fixedItemWidth && {
              style: {
                width: fixedItemWidth,
              },
            })}
          >
            {_switch?.customIcon && _switch.customIcon}
            <Typography.Label
              size="small"
              color={
                current === _switch.key
                  ? selectedTextColor || 'neutral50'
                  : 'neutral400'
              }
            >
              {_switch.title}
            </Typography.Label>
            {_switch?.rightCustomIcon && _switch.rightCustomIcon}
          </ToggleItem>
        ))}

        <ToggleItemOverflow
          id="selected-switch"
          style={{
            ...selectedSwitchDynamicProps,
          }}
        />
      </ToggleWrapper>
    </SwitchToggleContainer>
  );
};
